import _util from '../../utils/';

const monthlyReportService = {
	initMonthlyReport(gets, resolve, reject) {
		_util.request({
			// url: '/api/HRWorkReportMyMonthly/Post',
			url: '/api/HRWorkReport/Post',
			params: gets,
			success: resolve,
			error: reject
		})
	},
	saveMonthlyReport(posts, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportMyMonthly/Post',
			method: 'post',
			data: posts,
			success: resolve,
			error: reject
		})
	},
	fetchMonthlyReportList(gets, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportMyMonthly/Get',
			params: gets,
			success: resolve,
			error: reject
		})
	},
	updateMonthlyReport(puts, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportMyMonthly/Put',
			method: 'put',
			data: puts,
			success: resolve,
			error: reject
		})
	},
	fetchMonthlyReportDetail(gets, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportMyMonthly/Details',
			params: gets,
			success: resolve,
			error: reject
		})		
	},
	multiDeleteMonthlyReport(deletes, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportMyMonthly/Delete',
			method: 'delete',
			data: deletes,
			success: resolve,
			error: reject
		})			
	},
	submitMonthlyReport(puts, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportMyMonthly/SubmitReport',
			method: 'put',
			data: puts,
			success: resolve,
			error: reject
		})		
	},
	fetchLeaderMonthlyReportList(params, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportMonthlyManagement/Get',
			params: params,
			success: resolve,
			error: reject
		})			
	},
	fetchLeaderMonthlyReportDetail(params, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportMonthlyManagement/Details',
			params: params,
			success: resolve,
			error: reject
		})			
	},
	replyMonthlyReport(posts, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportReply/Post',
			method: 'post',
			data: posts,
			success: resolve,
			error: reject
		})	
	},
	multiNotifyMonthlyReport(posts, resolve, reject) {
		_util.request({
			url: '/api/HRWorkReportMonthlyManagement/SendNotification',
			method: 'post',
			data: posts,
			success: resolve,
			error: reject
		})	
	}	
}

export default monthlyReportService




// WEBPACK FOOTER //
// ./src/services/WorkReport/monthly-report-service.js